module.exports = __webpack_public_path__ + "media/images/Ellipse-innactive-e3e354271e7831c122c0549fb318618e.svg";